"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SizeExceededModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_intl_1 = require("react-intl");
var material_1 = require("@mui/material");
var Close_1 = __importDefault(require("@mui/icons-material/Close"));
var common_1 = require("../../../common");
var styles = __importStar(require("./SizeExceededModal.module.css"));
var SizeExceededModal = function (_a) {
    var isOpen = _a.isOpen, buttonColor = _a.buttonColor, setIsOpen = _a.setIsOpen;
    var intl = (0, react_intl_1.useIntl)();
    var onClose = function () { return setIsOpen(false); };
    return ((0, jsx_runtime_1.jsxs)(material_1.Dialog, __assign({ open: isOpen, onClose: onClose, "aria-labelledby": 'alert-dialog-title', "aria-describedby": 'alert-dialog-description', PaperComponent: function (props) { return (0, jsx_runtime_1.jsx)(material_1.Paper, __assign({}, props, { className: styles.sizeExceededModalPaper })); } }, { children: [(0, jsx_runtime_1.jsxs)(material_1.DialogTitle, { children: [intl.formatMessage({ id: 'sizeExceededModalTitle' }), (0, jsx_runtime_1.jsx)(material_1.IconButton, __assign({ "aria-label": 'close', onClick: onClose, sx: { p: 0, color: function (theme) { return theme.palette.grey[500]; } } }, { children: (0, jsx_runtime_1.jsx)(Close_1.default, {}) }))] }), (0, jsx_runtime_1.jsx)(material_1.DialogContent, __assign({ className: styles.sizeExceededModalContent }, { children: (0, jsx_runtime_1.jsx)(material_1.DialogContentText, { children: intl.formatMessage({ id: 'sizeExceededModalText' }, { maxSize: common_1.MAX_FILES_SIZE_MEGABYTES }) }) })), (0, jsx_runtime_1.jsx)(material_1.DialogActions, __assign({ className: styles.sizeExceededModalActions }, { children: (0, jsx_runtime_1.jsx)(material_1.Button, __assign({ onClick: onClose, autoFocus: true, className: styles.sizeExceededModalButton, sx: { backgroundColor: buttonColor, ':hover': { backgroundColor: buttonColor } } }, { children: intl.formatMessage({ id: 'ok' }) })) }))] })));
};
exports.SizeExceededModal = SizeExceededModal;
